import React from 'react';
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Link,
  TextField,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import ActivityIndicator from 'react-activity-indicator';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory, useLocation } from 'react-router-dom';
import * as AuthActions from '../../store/actions/auth';
import { useDispatch } from 'react-redux';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.virtus-one.com';

const useStyles = makeStyles((theme) => ({
  triggerButton: {
    backgroundColor: '#002D55',
    color: '#FFFFFF',
    marginRight: 0,
    maxHeight: 34,
    fontSize: 'clamp(0.72rem, 0.78vw, 0.9rem)',
    borderRadius: 18,
    textTransform: 'none',
    boxShadow: '0 10px 24px rgba(0, 45, 85, 0.18)',
    '&:hover': {
      backgroundColor: '#0a416f',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 68,
      height: 30,
      padding: '4px 10px',
      borderRadius: 18,
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 62,
      height: 28,
      padding: '3px 8px',
      borderRadius: 18,
    },
  },
  dialogPaper: {
    borderRadius: 22,
    background: 'linear-gradient(180deg, #f7faff 0%, #eef4fb 100%)',
    boxShadow: '0 28px 64px rgba(0, 45, 85, 0.18)',
    border: '1px solid rgba(0, 45, 85, 0.08)',
    overflow: 'hidden',
  },
  titleRoot: {
    paddingBottom: 0,
    color: '#002D55',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  titleContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  avatar: {
    width: 42,
    height: 42,
    background: 'linear-gradient(135deg, #fb741a 0%, #ff9a54 100%)',
    color: '#fff',
    boxShadow: '0 12px 24px rgba(251, 116, 26, 0.24)',
  },
  titleText: {
    color: '#002D55',
    fontWeight: 700,
    fontSize: '1.35rem',
    lineHeight: 1.2,
  },
  closeButton: {
    color: '#002D55',
  },
  introBox: {
    background: 'linear-gradient(180deg, rgba(220, 228, 235, 0.85) 0%, rgba(255, 255, 255, 0.95) 100%)',
    borderRadius: 18,
    padding: 20,
    marginBottom: 20,
  },
  formCard: {
    background: 'transparent',
    borderRadius: 18,
    padding: 20,
    marginBottom: 20,
    boxShadow: '0 12px 28px rgba(0, 45, 85, 0.08)',
    borderColor: 'rgba(0, 45, 85, 0.12)',
    borderWidth: 1,
    borderStyle: 'solid',
  },
  field: {
    marginBottom: 16,
    '& .MuiOutlinedInput-root': {
      borderRadius: 14,
      backgroundColor: '#fff',
      '& fieldset': {
        borderColor: 'rgba(0, 45, 85, 0.14)',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(0, 45, 85, 0.28)',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#fb741a',
      },
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#002D55',
    },
  },
  primaryButton: {
    background: '#fb741a',
    color: '#fff',
    fontWeight: 600,
    borderRadius: 18,
    padding: '12px 22px',
    boxShadow: '0 14px 30px rgba(251, 116, 26, 0.24)',
    '&:hover': {
      background: '#002D55',
    },
  },
  secondaryButton: {
    border: '1px solid #002D55',
    color: '#002D55',
    background: 'transparent',
    fontWeight: 600,
    borderRadius: 18,
    padding: '12px 22px',
  },
  actionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginTop: 8,
    flexWrap: 'wrap',
  },
  linkRow: {
    marginTop: 18,
  },
  link: {
    color: '#005c97',
    fontWeight: 500,
  },
  statusCard: {
    background: 'linear-gradient(180deg, rgba(220, 228, 235, 0.85) 0%, rgba(255, 255, 255, 0.95) 100%)',
    borderRadius: 18,
    padding: 18,
    marginBottom: 20,
  },
  statusText: {
    color: '#002D55',
    lineHeight: 1.7,
  },
}));

export default function Loginbotton({ onOpenClinicSignup, open, onOpenChange, showTrigger = true }) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [internalOpen, setInternalOpen] = React.useState(false);
  const [mode, setMode] = React.useState('login');
  const [userEmail, setUserEmail] = React.useState('');
  const [userPassword, setUserPassword] = React.useState('');
  const [formIsValid, setFormIsValid] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [resetStatus, setResetStatus] = React.useState('');
  const [resetError, setResetError] = React.useState('');

  const handleOpen = () => {
    if (onOpenChange) {
      onOpenChange(true);
    } else {
      setInternalOpen(true);
    }
    setMode('login');
    setResetStatus('');
    setResetError('');
  };

  const handleClose = () => {
    if (isLoading) {
      return;
    }

    if (onOpenChange) {
      onOpenChange(false);
    } else {
      setInternalOpen(false);
    }
  };

  const handleInput = (event) => {
    switch (event.target.id) {
      case 'email':
        setUserEmail(event.target.value);
        break;
      case 'password':
        setUserPassword(event.target.value);
        break;
      default:
        break;
    }

    setFormIsValid(true);
    if (resetError) {
      setResetError('');
    }
  };

  const handleOpenSignup = () => {
    if (onOpenChange) {
      onOpenChange(false);
    } else {
      setInternalOpen(false);
    }
    setMode('login');
    if (onOpenClinicSignup) {
      onOpenClinicSignup();
      return;
    }

    history.push('/?openClinicSignup=1');
  };

  const handleRequestPasswordReset = async () => {
    const normalizedEmail = String(userEmail || '').trim().toLowerCase();
    if (!normalizedEmail) {
      setResetError('Enter the email address tied to your account first.');
      return;
    }

    setIsLoading(true);
    setResetError('');

    try {
      const response = await fetch(`${BACKEND_URL}/account/password-reset/request/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: normalizedEmail }),
      });

      const data = await response.json().catch(() => ({}));
      setIsLoading(false);

      if (!response.ok) {
        setResetError(data.error || 'Unable to start password reset right now. Please try again later.');
        return;
      }

      setResetStatus(data.message || 'If an account exists for that email, a password reset link has been sent.');
    } catch (error) {
      setIsLoading(false);
      setResetError('Unable to start password reset right now. Please try again later.');
    }
  };

  const login = async () => {
    if (!formIsValid) {
      return;
    }

    const action = AuthActions.login(userEmail, userPassword);
    setIsLoading(true);

    try {
      const result = await dispatch(action);
      setIsLoading(false);
      handleClose();
      const searchParams = new URLSearchParams(location.search || '');
      const redirectTarget = searchParams.get('redirect');
      const role = result && result.role ? result.role : null;
      const adminRoles = ['careprovider_admin', 'care_provider', 'clinic_admin', 'admin', 'staff', 'care_staff', 'physiotherapist'];
      if (redirectTarget) {
        history.push(redirectTarget);
        return;
      }
      if (role && adminRoles.includes(role.role_type)) {
        try {
          localStorage.setItem('vp_activeTab', 'clinicCalendar');
        } catch (error) {
          // ignore storage errors
        }
        history.push('/admin_dashboard');
      } else {
        history.push('/physiotherapeutic_plan');
      }
    } catch (err) {
      setIsLoading(false);
      alert(err);
    }
  };

  return (
    <div>
      {showTrigger ? (
        <Button
          aria-haspopup="dialog"
          variant="contained"
          onClick={handleOpen}
          className={classes.triggerButton}
        >
          Login
        </Button>
      ) : null}

      <Dialog
        open={typeof open === 'boolean' ? open : internalOpen}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: classes.dialogPaper }}
      >
        <DialogTitle className={classes.titleRoot}>
          <div className={classes.titleRow}>
            <div className={classes.titleContent}>
              <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
              </Avatar>
              <div>
                <Typography component="h2" className={classes.titleText}>
                  Sign in
                </Typography>
                <Typography variant="body2" style={{ color: '#3d5a80' }}>
                  As clinic or patient.
                </Typography>
              </div>
            </div>
            <IconButton className={classes.closeButton} onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          {mode === 'reset' && resetStatus ? (
            <Box className={classes.statusCard}>
              <Typography variant="body2" className={classes.statusText}>
                {resetStatus}
              </Typography>
            </Box>
          ) : null}

          <Box className={classes.formCard}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="email"
              label="Email address"
              name="email"
              autoComplete="email"
              autoFocus
              value={userEmail}
              className={classes.field}
              onChange={handleInput}
            />
            {mode === 'login' ? (
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                value={userPassword}
                autoComplete="current-password"
                className={classes.field}
                onChange={handleInput}
              />
            ) : (
              <Typography variant="body2" style={{ color: '#3d5a80', marginBottom: 16, lineHeight: 1.7 }}>
                Enter your email address and we will send a time-limited single-use reset link if the account exists.
              </Typography>
            )}

            {resetError ? (
              <Typography variant="body2" style={{ color: '#b3261e', marginBottom: 16 }}>
                {resetError}
              </Typography>
            ) : null}

            <div className={classes.actionRow}>
              <Button className={classes.secondaryButton} onClick={mode === 'login' ? handleClose : () => { setMode('login'); setResetError(''); setResetStatus(''); }} disabled={isLoading}>
                {mode === 'login' ? 'Cancel' : 'Back to sign in'}
              </Button>
              {isLoading ? (
                <ActivityIndicator number={3} duration={100} activeColor="#0070bf" borderWidth={2} borderRadius="50%" diameter={19} />
              ) : (
                <Button variant="contained" className={classes.primaryButton} onClick={mode === 'login' ? login : handleRequestPasswordReset}>
                  {mode === 'login' ? 'Sign In' : 'Send reset link'}
                </Button>
              )}
            </div>

            <Grid container spacing={2} className={classes.linkRow}>
              <Grid item xs={12} sm={6}>
                <Link
                  href="#"
                  variant="body2"
                  className={classes.link}
                  onClick={(event) => {
                    event.preventDefault();
                    setMode('reset');
                    setResetError('');
                    setResetStatus('');
                  }}
                >
                  Forgot password?
                </Link>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Link
                  href="#"
                  variant="body2"
                  className={classes.link}
                  onClick={(event) => {
                    event.preventDefault();
                    handleOpenSignup();
                  }}
                >
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}
